export default "__VITE_ASSET__BzPgJrOi__"